import React from 'react';
import { Bot, Trophy, Lock } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { MobileCarousel } from '@/components/MobileCarousel';

export const DifferentiationSection: React.FC = () => {
  const isMobile = useIsMobile();

  const benefits = [
    {
      icon: Bot,
      title: "AI-Powered Matching",
      description: "Personalized recommendations in minutes"
    },
    {
      icon: Trophy, 
      title: "Top-Rated Carriers",
      description: "Access to trusted providers, not just one company"
    },
    {
      icon: Lock,
      title: "Privacy Protected", 
      description: "Your data is secure and never sold"
    }
  ];

  return (
    <section className="py-12 bg-accent/30">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Mobile Section Header */}
          {isMobile && (
            <div className="text-center mb-8 mt-4 px-4">
              <h2 className="text-2xl font-bold text-foreground mb-3">
                Why Safurra <span className="text-primary">Stands Out</span>
              </h2>
              <p className="text-base text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                We compare dozens of top-rated carriers to match you with the best fit for your needs.
              </p>
            </div>
          )}
          
          {isMobile ? (
            <MobileCarousel
              items={benefits.map((benefit, index) => (
                <div key={index} className="bg-background rounded-2xl p-6 border border-border shadow-sm text-center">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <benefit.icon className="h-8 w-8 text-primary" aria-hidden="true" />
                  </div>
                  <h3 className="font-semibold text-foreground mb-3">{benefit.title}</h3>
                  <p className="text-sm text-muted-foreground">
                    {benefit.description}
                  </p>
                </div>
              ))}
              ariaLabel="Why Safurra benefits carousel"
            />
          ) : (
            <div className="grid md:grid-cols-3 gap-8 text-center">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex flex-col items-center space-y-3">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                    <benefit.icon className="h-8 w-8 text-primary" aria-hidden="true" />
                  </div>
                  <h3 className="font-semibold text-foreground">{benefit.title}</h3>
                  <p className="text-sm text-muted-foreground">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};